// Activity pricing: shared rate plan dialog fields and payload of price row and activity calendar products
// (ProductDetails' "Rates" section and ActivityRatesEditor).
export default {
  methods: {
    rateplanTermsList (termsOptions) {
      return Array.isArray(termsOptions) ? termsOptions : Object.values(termsOptions || {})
    },
    rateplanTermsLabel (rateplan, termsOptions) {
      if (!parseInt(rateplan.terms_id)) {
        return this._('As the product')
      }
      const terms = this.rateplanTermsList(termsOptions).find(t => String(t.id) === String(rateplan.terms_id))
      return terms ? terms.name : '#' + rateplan.terms_id
    },
    rateplanCancellationText (rateplan) {
      if (rateplan.allow_cancellation_request === null || rateplan.allow_cancellation_request === undefined || rateplan.allow_cancellation_request === '') {
        return this._('As the product')
      }
      return parseInt(rateplan.allow_cancellation_request) ? this._('Yes') : this._('No')
    },
    /**
     * Name, description, terms, cancellation requests and default flag of a rate plan.
     * isFirst: a new plan of a product without plans is the default by default.
     */
    rateplanBaseFields (rateplan, termsOptions, isFirst) {
      let cancellation = 'product'
      if (rateplan && rateplan.allow_cancellation_request !== null && rateplan.allow_cancellation_request !== undefined && rateplan.allow_cancellation_request !== '') {
        cancellation = parseInt(rateplan.allow_cancellation_request) ? '1' : '0'
      }
      const cancellationOptions = [
        { value: 'product', name: this._('As the product') },
        { value: '0', name: this._('No') }
      ]
      if (cancellation === '1') { // Only kept for plans that were saved as allowed elsewhere
        cancellationOptions.push({ value: '1', name: this._('Yes') })
      }
      return [
        { title: this._('Name'), type: 'text', name: 'title', defaultValue: rateplan ? rateplan.title : '', localized: true, placeholder: this._('For example Flexible or Non-refundable') },
        {
          title: this._('Description'),
          type: 'textarea',
          name: 'description',
          defaultValue: rateplan ? rateplan.description : '',
          localized: true,
          rows: 2,
          placeholder: this._('Shown to customers when they choose a rate')
        },
        {
          title: this._('Terms'),
          type: 'select',
          name: 'terms_id',
          half: 'left',
          defaultValue: rateplan && parseInt(rateplan.terms_id) ? String(rateplan.terms_id) : 0,
          options: [{ value: 0, name: this._('As the product') }].concat(this.rateplanTermsList(termsOptions).map(t => ({ value: String(t.id), name: t.name })))
        },
        {
          title: this._('Customers can request cancellation'),
          type: 'select',
          name: 'allow_cancellation_request',
          half: 'right',
          defaultValue: cancellation,
          options: cancellationOptions
        },
        {
          title: this._('Default rate'),
          type: 'checkbox',
          name: 'is_default',
          defaultValue: rateplan && parseInt(rateplan.is_default) ? '1' : (!rateplan && isFirst ? '1' : '0')
        }
      ]
    },
    rateplanBasePayload (data) {
      return {
        title: data.title,
        description: data.description || '',
        version: this.version,
        terms_id: parseInt(data.terms_id) ? parseInt(data.terms_id) : '',
        allow_cancellation_request: !data.allow_cancellation_request || data.allow_cancellation_request === 'product' ? null : parseInt(data.allow_cancellation_request),
        is_default: parseInt(data.is_default) ? 1 : 0
      }
    }
  }
}
